import React from 'react'
import { observer } from 'mobx-react'
import usePortManager from '../hooks/use-port-manager'

function WhenCondition (props) {

  const manager = usePortManager()
  if (manager.when(props.condition, props.arg) !== true) {
    return null
  }
  return (
    <React.Fragment>
      {props.children}
    </React.Fragment>
  )
}

export default observer(WhenCondition)